import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M9.965 24.121a.606.606 0 0 0-.606-.606H6.91a3.03 3.03 0 0 1-3.03-3.03V15.03c0-1.943.072-3.728.216-5.357A3.03 3.03 0 0 1 6.9 6.918c3.5-.248 6.528-.373 9.081-.373 2.557 0 5.598.125 9.12.374a3.03 3.03 0 0 1 2.805 2.756c.144 1.627.216 3.413.216 5.355v5.455a3.03 3.03 0 0 1-3.03 3.03h-2.415a.606.606 0 1 0 0 1.212h2.415c2.343 0 4.242-1.9 4.242-4.242V15.03c0-1.977-.073-3.797-.22-5.462a4.242 4.242 0 0 0-3.927-3.858c-3.55-.251-6.618-.377-9.206-.377-2.585 0-5.64.126-9.167.376a4.242 4.242 0 0 0-3.925 3.858 62.218 62.218 0 0 0-.221 5.463v5.455a4.242 4.242 0 0 0 4.242 4.242h2.45a.606.606 0 0 0 .606-.606Zm9.372 2.759a1.818 1.818 0 0 0 1.316-2.64l-3.042-5.799a1.818 1.818 0 0 0-3.22 0l-3.044 5.807a1.818 1.818 0 0 0 1.314 2.638c1.01.167 2.11.25 3.302.25 1.207 0 2.332-.085 3.374-.256Z",
      clipRule: "evenodd"
    }
  )
);
var SvgPresentFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var PresentFilled_default = SvgPresentFilled;

export { PresentFilled_default as default };
